const menuTitles = {
  dashboard: "Dashboard",
  questions: "Question",
  projectManagement: "Project Management",
  forms: "Form",
  addForms: "Add Form",
  addProjectManagement: "Add Project Management",
  clientManagement: "Client Management",
  userManagement: "User Management",
  // template: "Template",
  channel: "Channel",
  addChannel: "Add Channel",
  serviceRequest: "Service Request",
  feedback: "Staff Connect",
  caseHistory: "Case History",
  category: "Category",
  transaction: "Transaction",
  submittedForm: "Submitted Form",
  feedbackReport: "Staff Connect Report",
  monthlyReport: "Monthly Report",
  hrAndAdminWork: "HR and Admin Work",
  task: "Task",
  email: "Email",
  todo: "Task Management",
  taskDetails: "Task Details",
  itSupportReports: "IT Support Reports",
};

export { menuTitles };
